import type { CompanyProfile, MeResponse } from "../types";
import { apiFetch, apiFetchWithAuthRevision } from "./client";
import { authRecovery } from "./authRecovery";

/** 現在の店・プラン・今月の使用状況。埋め込みアプリの起動時に必ず1回叩く。 */
export async function getMe(): Promise<MeResponse> {
  const { data: me, accessRevision } = await apiFetchWithAuthRevision<MeResponse>("/api/me");
  authRecovery.acceptMeStatus(me, accessRevision);
  return me;
}

/** 帳票へ印字する発行者情報を更新する。空文字は backend が未設定へ正規化する。 */
export function updateCompanyProfile(profile: CompanyProfile): Promise<CompanyProfile> {
  return apiFetch<CompanyProfile>("/api/me/company-profile", {
    method: "PATCH",
    body: profile,
  });
}
